import { render, staticRenderFns } from "./trade.vue?vue&type=template&id=355283c3&scoped=true&"
import script from "./trade.vue?vue&type=script&lang=js&"
export * from "./trade.vue?vue&type=script&lang=js&"
import style0 from "./trade.vue?vue&type=style&index=0&id=355283c3&prod&lang=scss&scoped=true&"
import style1 from "./trade.vue?vue&type=style&index=1&id=355283c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355283c3",
  null
  
)

export default component.exports